import { Injectable } from '@angular/core';

import { ProblemModel } from '@generativ/much-smarter-models';

@Injectable({ providedIn: 'root' })
export class UtilitiesService {

  constructor() {
  }


  problemHasContentPassage(problem: ProblemModel): boolean {
    return problem.passage && problem.passage.content && problem.passage.content.length > 0;
  }

  getVimeoIdFromLink(url: string): string {
    const regExp = /\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
    const match = url.match(regExp);

    if (match) {
      return match[2];
    }

  }

}
